import { z } from 'zod';
import { http } from '@/api/http';
import { bigintString } from '@/api/zod-helpers';
import { decodeJwtExp, type Session } from './session';

/** POST /api/auth/login → {code, message, data: {token, user}}. Failure is HTTP 401 with body code 403. */
const loginResponse = z.object({
  data: z.object({
    token: z.string().min(1),
    user: z.object({
      Id: bigintString,
      OperatorId: bigintString.nullable().optional(),
      Email: z.string(),
      FullName: z.string().nullable().optional(),
      Permission: bigintString,
      Brand: z.string().nullable().optional(),
    }),
  }),
});

export async function login(email: string, password: string): Promise<Session> {
  const res = await http('/auth/login', { method: 'POST', body: { email, password }, auth: false }, loginResponse);
  const { token, user } = res.data;
  return {
    token,
    expiresAt: decodeJwtExp(token),
    user: {
      id: user.Id,
      operatorId: user.OperatorId ?? null,
      email: user.Email,
      fullName: user.FullName ?? user.Email,
      permission: user.Permission,
      brand: user.Brand ?? null,
    },
  };
}

/** The server revokes nothing (tokens live until `exp`), so this is best effort. */
export async function logout(): Promise<void> {
  try {
    await http('/auth/logout', { method: 'POST' });
  } catch {
    // Logging out locally is what matters.
  }
}
